import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"
import { selectActivatedFireId } from "features/map/control/selectors"
import { useAppSelector } from "integrations/redux/hooks"

export function useIsEditor() {
    const projectId = useAppSelector(selectActivatedFireId)
    return useWorkspacePermissions(projectId).isEditor
}
